// extracted by mini-css-extract-plugin
module.exports = {"head":"Expandable_head__3GIgf","title":"Expandable_title__3xPLF","svg":"Expandable_svg__vVGIX","activeSvg":"Expandable_activeSvg__Jguqh"};